import { requestGooseAPI, getAPIPath } from '../shared/request'
import { APIResourceClientDtoResponse, ResourceAvailabilityDto } from '../types'
import { CLIENT_RESOURCE_AVAILABILITY, CLIENT_RESOURCES_PATH } from '../types/constants'
import { type } from '../types/goose-api'
import { ResourceAvailabilityFilter } from './admin_resource.service'

export type TFilters = {
  subtype?: 'GROOMING_STAFF'
  type?: 'PERSON' | 'THING' | 'SPACE'
}

export const ClientResourceService = {
  list: async (locationId: string, filters: TFilters): Promise<APIResourceClientDtoResponse> => {
    return requestGooseAPI<APIResourceClientDtoResponse>({
      url: getAPIPath(CLIENT_RESOURCES_PATH, { locationId: locationId }),
      method: 'GET',
      params: filters,
    })
  },

  getResourceAvailability: (
    locationName: string,
    filters: ResourceAvailabilityFilter
  ): Promise<ResourceAvailabilityDto> => {
    return requestGooseAPI<ResourceAvailabilityDto>({
      url: getAPIPath(CLIENT_RESOURCE_AVAILABILITY, { locationId: locationName }),
      method: 'GET',
      params: filters,
    })
  },
}
